const getYoutubeId = (text)=>{
    var regExp = /\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\s\/<>"']*)/mi;
    var match = text.match(regExp);
    return (match && match[1].length==11)? match[1] : null;
};

export default getYoutubeId;